{{ call.date | date: 'd MMM y' }} •
{{ call.date | date: 'HH:mm' }}
@if (call.duration !== null) {
  • {{ call.duration | duration }}
}
@if (!call.isUpcoming && !call.isOngoing) {
  @let requestOptions = (retentionExtensionRequestOptions$ | async)?.data ?? null;
  @if (
    requestOptions !== null &&
    requestOptions.isEnabled &&
    call.retentionPeriodExpirationDate !== null &&
    (requestOptions.pendingRequest !== null || requestOptions.availableExtensionsInDays.length > 0)
  ) {
    @if (requestOptions.pendingRequest; as pendingRequest) {
      <span class="expiry-badge pending" [class.urgent]="isExpiryUrgent" [matTooltip]="getPendingRequestTooltip(pendingRequest)">
        {{ getExpiryText() }}
        <span class="separator">•</span>
        <mat-icon>hourglass_top</mat-icon>
        {{ 'CALLS.RETENTION_EXTENSION_REQUEST.PENDING_BADGE' | translate }}
      </span>
    } @else {
      <button
        type="button"
        class="expiry-badge requestable"
        [class.urgent]="isExpiryUrgent"
        [matTooltip]="getRequestableExpiryTooltip()"
        (click)="openRequestRetentionExtensionDialog(requestOptions)"
      >
        {{ getExpiryText() }}
        <mat-icon>more_time</mat-icon>
      </button>
    }
  } @else {
    <span class="expiry-badge" [class.urgent]="isExpiryUrgent" [matTooltip]="getExpiryTooltip()">
      {{ getExpiryText() }}
    </span>
  }
  @if (call.processingStatus === null) {
    <app-meeting-health-indicator [userActionsItems]="getMeetingHealthItems()" [avgConfidenceScore]="call.avgConfidenceScore"></app-meeting-health-indicator>
  }
}
@if (call.callSetIndex !== null && call.callSetSize !== null && call.callSetSize > 1) {
  <span class="part-badge" [matTooltip]="'CALLS.PART_BADGE_TOOLTIP' | translate: { index: call.callSetIndex + 1, total: call.callSetSize }">
    {{ 'CALLS.PART_BADGE_TEXT' | translate: { index: call.callSetIndex + 1, total: call.callSetSize } }}
  </span>
}
@if (call.processingStatus) {
  <span class="processing-progress">
    <span class="processing-progress-label">
      @if (isSplitting) {
        {{ 'CALLS.PROCESSING_STATUSES.SPLITTING_CALL' | translate }}
      } @else if (isCheckingAgendaValidity) {
        {{ 'CALLS.PROCESSING_STATUSES.CHECKING_AGENDA_DOCUMENT' | translate }}
      } @else if (call.processingStatus === 'GENERATING_MINUTES' && call.minutesGenerationTemplateProgress; as tp) {
        {{ 'CALLS.PROCESSING_STATUSES.GENERATING_MINUTES_FOR_AGENDA_ITEM' | translate: { level: tp.level } }}
      } @else {
        {{ 'CALLS.PROCESSING_STATUSES.' + call.processingStatus | translate }}
      }
    </span>
    @if (call.processingProgress !== null && !isCheckingAgendaValidity) {
      <app-progress-loader [value]="call.processingProgress" loading></app-progress-loader>
      <span class="processing-progress-percentage">{{ call.processingProgress }}%</span>
    } @else {
      <app-progress-loader indeterminate></app-progress-loader>
    }
  </span>
}
